import common from './common/common.json';
import errors from './common/errors.json';
import analytics from './pages/analytics.json';
import bulks from './pages/bulks.json';
import contacts from './pages/contacts.json';
import home from './pages/home.json';
import newsletterTypes from './pages/newsletter-types.json';
import notFound from './pages/not-found.json';
import subscriptions from './pages/subscriptions.json';
import templates from './pages/templates.json';

export const translationsEN = {
  common,
  errors,
  'page:analytics': analytics,
  'page:bulks': bulks,
  'page:contacts': contacts,
  'page:home': home,
  'page:newsletter-types': newsletterTypes,
  'page:not-found': notFound,
  'page:subscriptions': subscriptions,
  'page:templates': templates,
};
